import { LogOut, Bell, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ROLE_LABELS } from "@/config/navigation";

export default function Topbar({ user, onLogout }) {
  const initials = (user.name || user.email || "?")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-border"
    >
      <div className="h-16 px-6 flex items-center gap-4">
        <div className="hidden lg:flex items-center gap-2 flex-1 max-w-md">
          <div className="relative w-full">
            <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              data-testid="topbar-search-input"
              placeholder="Buscar paciente, sessão, terapeuta…"
              className="pl-9 h-10 rounded-lg bg-muted/40 border-border"
            />
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            data-testid="topbar-notifications-btn"
            className="rounded-full text-slate-600 hover:text-primary hover:bg-secondary/60"
          >
            <Bell className="h-5 w-5" />
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="topbar-user-menu-trigger"
                className="flex items-center gap-3 px-2 py-1.5 rounded-lg hover:bg-secondary/60 transition-colors"
              >
                <Avatar className="h-9 w-9">
                  <AvatarImage
                    src="https://images.unsplash.com/photo-1618592795475-a3a169db6f87?w=100"
                    alt=""
                  />
                  <AvatarFallback className="bg-primary text-white text-sm">
                    {initials}
                  </AvatarFallback>
                </Avatar>
                <div className="hidden sm:block text-left">
                  <p className="text-sm font-semibold text-slate-800 leading-none">
                    {user.name}
                  </p>
                  <p className="text-[11px] text-muted-foreground mt-0.5">
                    {ROLE_LABELS[user.role] || user.role}
                  </p>
                </div>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="flex flex-col">
                  <span className="text-sm">{user.name}</span>
                  <span className="text-xs text-muted-foreground font-normal">
                    {user.email}
                  </span>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                data-testid="topbar-logout-btn"
                onClick={onLogout}
                className="text-destructive focus:text-destructive"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Sair
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
